package org.multiplatform.kotfolio.pages.listing

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.WebImage
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Resources

@Page("chopping_board")
@Composable
fun ChoppingBoardListing() {
    BlogLayout(
        PageProperties(
            "Chopping Board",
            ""
        ),
        BlogProperties("Listing", "Chopping Board (Steel Food Grade 304, Wooden)")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            WebImage(
                src = Resources.Images.CHOPPING_BOARD_PRODUCT,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "Chopping Board"
            )

            SpanText(
                text = "Title",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Stainless Steel Chopping Board (Vegetable, Fruit Cutting, Meat, Fruits, Kneeding, Cake Prep)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Stainless Steel Counter Top Chopping Board",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Floral Engraved Countertop Chopping Board",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Food-Grade 304, Anti-Rust, Cutting Veggies, Kneading Dough",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Stainless Steel Cutting Board for kitchen",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Stainless Steel Counter Top Chopping Board",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Heavy Duty Chopping-Board",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Heavy Duty Chopping-Board (Size 31.8CM X 21CM)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Description",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Meet the stainless steel chopping board designed for kitchens that prioritise hygiene and precision. Made for effortless prep, this durable cutting board combines food-grade stainless steel, a non-porous surface, and a built-in measurement scale for everyday use.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Unbreakable and Sturdy: Built to withstand heavy-duty use, making it a reliable addition to your kitchen.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Easy to Clean: Stainless steel is easy to clean and sanitize, ensuring excellent hygiene after every use.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Minimalist Look - Blends beautifully into modern kitchen spaces",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Built for High Use - Strong enough for daily chopping, prepping and more",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Multiple Sizes Available - From compact to full countertop coverage",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Healthy and Hygienic: Stainless steel is non-porous, preventing the absorption of odors, flavors, and harmful bacteria.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Safe and Durable: Resistant to scratches, cracks, and dents, ensuring a safe and long-lasting kitchen accessory.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Say Goodbye to Mouldy Wood and Chipped Plastic Boards: Our super-strong steel board handles tough cuts with ease, providing long-lasting, confident chopping without jitters or nicks.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hygienic and Safe: Keeps your food free from mold and bacteria, ensuring healthy meals every time.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Gentle on Knives: Our stainless steel board is super-soft on knives, making it a durable and reliable choice for smooth chopping.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Repels Germs: Stainless steel board repels odors and stains, keeping your food fresh and safe from unhealthy plastic chips and wooden moldy bacteria.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Kitchen Adventure Companion: Perfect for dicing juicy veggies on its mirror-finish surface, making your kitchen experience colorful and joyful.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Stainless Steel 304 grade: Chopping Board is made out of Stainless Steel 304 grade with 1.5 mm thickness, which is the best food-grade stainless steel available in the world. ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Made with SS 202 Stainless Steel - Durable, food-safe and rust-resistant",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Design: Rounded corner protection design, which will not hurt your hands when cutting. The sound is low and does not cause discomfort.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Design: Crafted from food-grade stainless steel, this chopping board features a smooth finish and an integrated twelve-centimetre measurement marking scale for accurate prep. The thick, rigid metal construction supports daily kitchen tasks, while smooth, rounded edges and bent, raised sides help keep the board steady on countertops. A flat, wide workspace, laser-etched markings, and a clean professional look define its design.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Wipes Clean in Seconds - No scrubbing or soaking required",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "No Smells. No Stains. No Bacteria. - A hygienic alternative to wood or plastic",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Benefits: The stainless steel surface resists bacteria, stains, and odours while remaining easy to clean. Raised edges improve cutting control and help protect countertops during use. Non-porous and durable, it handles both meat and vegetables without retaining smells, making it a practical alternative to wooden boards.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Specification",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Color: ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Antibacterial, Smooth Surface",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Material: Stainless Steel",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Dimensions: Length - 35.5 cm, Width - 25 cm, Thickness - 1.5 mm",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Small Chopping Board Dimension | Weight: 30 cm x 20 cm x 1 cm | 0.68 Kg",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Large Chopping Board Dimension | Weight: 34 cm x 24 cm x 1 cm | 0.98 Kg",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Package Contents: 1 - Piece Chopping BoardColor: Silver",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Product Care: Hand Wash and Dishwasher Safe",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}

//https://nestasia.in/products/stainless-steel-counter-top-chopping-board
//https://activlife.in/products/regular-chopping-board
//https://www.nextdirect.com/in/en/style/st830369/946014
//https://nestasia.in